<template>
    <div class="bg-light position-fixed top-50 start-50 translate-middle w-75 border border-danger p-2"
        style="border-radius: 10px">
        <div class="container overflow-auto w-100 p-2" style="max-height:80vh">
            <button class="btn-close float-end mt-3 me-3" @click.prevent="close"></button>
            <h3 class="mt-3"> <strong>Información previa del tubo {{ tubeLastInfo.name }} / {{
                tubeLastInfo.specification }}</strong>
            </h3>
            <div>
                <table class="table table-bordered my-auto mx-auto">
                    <thead>
                        <tr>
                            <th>Material: </th>
                            <td><strong>{{ tubeLastInfo.material }}</strong></td>
                            <th>Presentación: </th>
                            <td>{{ tubeLastInfo.presentation }}</td>
                        </tr>
                        <tr>
                            <th>Especificación: </th>
                            <td>{{ tubeLastInfo.specification }}</td>
                            <th>Familia de materia <br> prima asociada: </th>
                            <td>{{ rawMatName }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Nombre variable 1 (Altura): </th>
                            <td colspan="2">{{ tubeLastInfo.heightLabel }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Nombre variable 2 (Ancho): </th>
                            <td colspan="2">{{ tubeLastInfo.widthLabel }}</td>
                        </tr>
                        <tr>
                            <th colspan="2">Nombre variable 3 (Espesor): </th>
                            <td colspan="2">{{ tubeLastInfo.thicknessLabel }}</td>
                        </tr>
                        <tr>
                            <th>Cantidad de tipos de perfil
                                <br>asociados:
                            </th>
                            <td>{{ typesNumber }}</td>
                            <th>Precio <br> asociado: </th>
                            <td>{{ priceValue }}</td>
                        </tr>
                    </thead>
                </table>
                <div class="container">
                    <h3 class="mt-3"> <strong>Editar tubo</strong></h3>
                    <p><strong>Nota: </strong><mark>No podrá editar la familia de materia prima asociada.</mark>
                    </p>
                    <p><mark>Además, tenga presente que luego de hacer clic en el botón "Actualizar perfil", la
                            información que
                            sumistre a continuación, sutituirá por completo la información previa del tubo.</mark></p>
                    <p><strong>Atención:</strong> <mark>Los campos que se encuentren vacios al momento de hacer
                            clic en el botón "Actualizar tubo", contarán como
                            modifaciones.</mark></p>
                </div>
                <table class="table mx-auto my-auto">
                    <tbody>
                        <tr>
                            <th>
                                <p>
                                    <i class="requiredFields">* </i> Nuevo nombre:
                                </p>
                            </th>
                            <td colspan="2"><input type="text" class="form-control" v-model="editName"></td>
                            <td><mark><input class="form-check-input" type="checkbox" role="switch" id="notChangeName"
                                        v-model="notChangeName" />
                                    <i> Mantener nombre previo del tubo.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i>Nueva presentación:</p>
                            </th>
                            <td colspan="2"><input type="text" class="form-control" v-model="editPresentation"></td>
                            <td><mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangePresetation" v-model="notChangePresentation" />
                                    <i> Mantener pesentación previa del tubo.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i>Nueva especificación/norma:</p>
                            </th>
                            <td colspan="2"><input type="text" class="form-control" v-model="editSpecification"></td>
                            <td><mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangeSpecification" v-model="notChangeSpecification" />
                                    <i> Mantener especifiación/norma previa del tubo.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i>Asociar nuevo precio:</p>
                            </th>
                            <td colspan="3">
                                <select class="form-select" id="price_id" v-model="editPrice">
                                    <option selected value="0">Opciones disponibles...</option>
                                    <option v-for="price in pricesList" :key="price._id" v-bind:value="price.id">
                                        {{ price.name }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i>Nuevo nombre para la variable 1 (Altura):</p>
                            </th>
                            <td colspan="2"><select class="form-select" id="editHeightlabel" v-model="editHeightLabel">
                                    <option selected value="0">Opciones disponibles...</option>
                                    <option value="Altura del ala">Altura del ala</option>
                                    <option value="Altura total">Altura total</option>
                                    <option value="Altura total del perfil">
                                        Altura total del perfil
                                    </option>
                                </select></td>
                            <td><mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangeVar1Conception" v-model="notChangeVar1Conception" />
                                    <i> Mantener nombre previo de la variable 1.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i>Nuevo nombre para la variable 2 (Ancho):</p>
                            </th>
                            <td colspan="2">
                                <select class="form-select" id="editWidthlabel" v-model="editWidthLabel">
                                    <option selected value="0">Opciones disponibles...</option>
                                    <option value="Ancho del ala">Ancho del ala</option>
                                    <option value="Ancho total">Ancho total del ala</option>
                                    <option value="Ancho total del perfil">
                                        Ancho total del perfil
                                    </option>
                                </select>
                            </td>
                            <td>
                                <mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangeVar2Conception" v-model="notChangeVar2Conception" />
                                    <i> Mantener nombre previo de la variable 2.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <p><i class="requiredFields">* </i>Nuevo nombre para la variable 3 (Espesor):</p>
                            </th>
                            <td colspan="2"><select class="form-select" id="editThicknesslabel"
                                    v-model="editThicknessLabel">
                                    <option selected value="0">Opciones disponibles...</option>
                                    <option value="Espesor de la base">Espesor de la base</option>
                                    <option value="Espesor del alma central">
                                        Espesor del alma central
                                    </option>
                                    <option value="no_aplica">
                                        No aplica
                                    </option>
                                </select></td>
                            <td>
                                <mark><input class="form-check-input" type="checkbox" role="switch"
                                        id="notChangeVar3Conception" v-model="notChangeVar3Conception" />
                                    <i> Mantener nombre previo de la variable 3.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <th colspan="3">Añada la nueva clasifcación para el tubo, mediante la plantilla facilitada.
                            </th>
                            <td><button class="btn btn-danger">Descargar plantilla</button></td>
                        </tr>
                        <tr>
                            <td>
                                <h5 class="requiredFields">*</h5>
                            </td>
                            <td colspan="2">
                                <input type="file" ref="file" @change="previewFile()" class="form-control" />
                            </td>
                            <td><mark><input class="form-check-input" type="checkbox" role="switch" id="notChangeTubeTypes"
                                        v-model="notChangeTubeTypes" />
                                    <i> Mantener los tipos de tubos asociados al tubo anterior.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4"><button class="btn btn-danger" @click.prevent="saveChanges()">Actualizar
                                    tubo</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        sendTubeId: Number,
    },
    data() {
        return {
            //Variables before mount-mounted
            tubeLastInfo: [],
            pricesList: [],
            priceDefault: "tub",
            rawMatName: "",
            typesNumber: null,
            priceValue: 0,
            tubeTypesIds: [],
            //Edit fields
            editName: "",
            editPresentation: "",
            editSpecification: "",
            editPrice: 0,
            editHeightLabel: "",
            editWidthLabel: "",
            editThicknessLabel: "",
            fileTubeTypes: undefined,
            currentFile: undefined,
            //Variables that can not change
            notChangeName: false,
            notChangePresentation: false,
            notChangeSpecification: false,
            notChangeVar1Conception: false,
            notChangeVar2Conception: false,
            notChangeVar3Conception: false,
            notChangeTubeTypes: false,
            //Text at the view
            condition1: "El archivo debe contener los encabezados en la primera fila",
            condition2:
                "Puede agregar todas los registros que considere necesarios (filas).",
            condition3: "No debe alterar la cantidad de campos (columnas).",
            condition4: "El separador de decimales debe ser un punto (.).",
            condition5: "No debe tener separador de miles o millares.",
            condition6:
                "Asegurese de que los campos que tienen caracter como +, -, * o / son tratados como TEXTO en excel. De lo contrario pueden ser tomados como una operacion aritmética.",
            condition7:
                "No utilice ninguno de los siguientes caracteres $ % & | ° =  # ¿ ? ¡ ! '\"';",
            condition8:
                "Guarde el archivo en el mismo formato en que lo descargo (CSV delimitado por comas).",
        }
    },
    watch: {
        sendTubeId(newVal) {
            if (newVal !== null) {
                this.getMainTube();
            }
        },
    },
    methods: {
        async getMainTube() {
            try {
                if (!this.sendTubeId) {
                    console.log("Tube id not defined.");
                    return;
                }
                const res = await axios.get(RUTA_SERVIDOR + "api/tube/get", {
                    params: {
                        tube_id: this.sendTubeId,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                });
                this.tubeLastInfo = res.data[0];
                this.rawMatName = this.tubeLastInfo.rawMaterial["name"];
                this.typesNumber = this.tubeLastInfo.tubeTypes.length;
                this.priceValue = this.tubeLastInfo.priceId["value"];

                // Capturar el atributo id de cada objeto en tubeTypes
                this.tubeLastInfo.tubeTypes.forEach((tubeType) => {
                    this.tubeTypesIds.push(tubeType.id);
                });
                // console.log(this.tubeLastInfo);
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
        close() {
            this.$emit("close", false)
        },
        previewFile(event) {
            this.fileTubeTypes = this.$refs.file.files;
            // console.log(this.filetubeTypes);
            this.currentFile = this.fileTubeTypes.item(0);
            // console.log(this.currentFile);
        },
        async saveChanges() {
            try {
                await this.saveTubeChanges();
                await this.saveTubeTypesChanges();
                this.$emit("close", false);
            } catch (error) {
                console.log("An error was ocurred ", error);
                // Maneja el error según sea necesario
            }
        },
        async saveTubeChanges() {
            console.log("editPrice:", this.editPrice);
            if ((this.editName === "" && !this.notChangeName) || (this.editPresentation === "" && !this.notChangePresentation) ||
                (this.editSpecification === "" && !this.notChangeSpecification) || (this.editHeightLabel === "" && !this.notChangeVar1Conception) ||
                (this.editWidthLabel === "" && !this.notChangeVar2Conception) || (this.editThicknessLabel === "" && !this.notChangeVar3Conception) ||
                (this.editPrice == 0)
            ) {
                alert("Los campos están vacios, complete aquellos que son obligatorios marcados con *.");
                this.cleanFields();
            } else {
                let formData = new FormData();
                formData.append("tube_id", this.sendTubeId);
                this.notChangeName ? formData.delete("editName") : formData.append("editName", this.editName);
                this.notChangePresentation ? formData.delete("editPresentation") : formData.append("editPresentation", this.editPresentation);
                this.notChangeSpecification ? formData.delete("editSpecification") : formData.append("editSpecification", this.editSpecification);
                this.notChangeVar1Conception ? formData.delete("editHeigthLabel") : formData.append("editHeigthLabel", this.editHeightLabel);
                this.notChangeVar2Conception ? formData.delete("editWidthLabel") : formData.append("editWidthLabel", this.editWidthLabel);
                this.notChangeVar3Conception ? formData.delete("editThicknessLabel") : formData.append("editThicknessLabel", this.editThicknessLabel);
                formData.append("price_id", this.editPrice);
                // formData.forEach(element => {
                //   console.log(element)
                // });
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/tube/update",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    // console.log(res.data);

                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        this.editName === "" ? alert("Cambios sobre el tubo" + this.tubeLastInfo.name + " añadidos") : alert("Cambios sobre el tubo" + this.editName + " añadidos");
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
            }
        },
        async saveTubeTypesChanges() {
            if ((this.currentFile === undefined && !this.notChangeTubeTypes) || this.sendTubeId === 0 || this.tubeTypesIds.length === 0) {
                alert("Recuerde que debe subir un archivo .csv para actualizar la clasificación del tubo.");
                this.cleanFields();
            } else {
                if (this.sendTubeId != 0) {
                    let formData = new FormData();
                    formData.append("tube_type_ids", JSON.stringify(this.tubeTypesIds));
                    formData.append("tube_id", this.sendTubeId);
                    this.notChangeTubeTypes ? formData.delete("edit_csv_file") : formData.append("edit_csv_file", this.currentFile);
                    try {
                        let res = await axios.post(
                            RUTA_SERVIDOR + "api/tube/type/update",
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    Authorization: "Bearer " + localStorage.getItem("token"),
                                },
                            }
                        );
                        //console.log(res.data);
                        if (!res.data) {
                            console.log("There has been a different error with the data.");
                        } else {
                            this.editName === "" ? alert("Clasificación para el tubo " + this.tubeLastInfo.name + " atualizada con exito!") : alert("Clasificación para el tubo " + this.editName + " atualizada con exito!");
                            this.$emit("close", false);
                        }
                    } catch (err) {
                        console.log(`There has been an error ${err}`);
                    }
                    location.reload();
                    this.cleanFields();
                } else {
                    alert(
                        "Id " + this.sendTubeId + " no encontrado."
                    );
                }
            }
        },
        cleanFields() {
            this.editPresentation = "";
            this.editSpecification = "";
            this.editPrice = 0;
            this.currentFile = undefined;
            this.fileTubeTypes = undefined;
            this.tubeTypesIds = [];
            this.tubeLastInfo = [];
            this.notChangeName = false;
            this.notChangePresentation = false;
            this.notChangeSpecification = false;
            this.notChangeVar1Conception = false;
            this.notChangeVar2Conception = false;
            this.notChangeVar3Conception = false;
            this.notChangeTubeTypes = false;
        }
    },
    mounted() {
        this.getMainTube();
        axios
            .get(RUTA_SERVIDOR + "api/price/list", {
                params: {
                    price_type: this.priceDefault,
                },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
            .then((res) => (this.pricesList = res.data))
            .catch((err) => console.log(`There has been an error ${err}`));
    },

}
</script>
<style scoped>
.requiredFields {
    color: #9d0e15;
}
</style>